import * as tooltips from 'src/app/shared/constants/tooltips';
import { ConnectionFamilyType } from '../models/connection-type';

export function isSqlConnectionType(connectionType?: string): boolean {
    const sqlConnectionTypes = ['sql', 'sql1', 'sql2'];
    return sqlConnectionTypes.some(ct => ct === connectionType?.toLowerCase());
}

export function isOracleConnectionType(connectionType?: string): boolean {
    const oracleConnectionTypes = ['ora1', 'ora2', 'ora1nc'];
    return oracleConnectionTypes.some(ct => ct === connectionType?.toLowerCase());
}

export function isSftpConnectionType(connectionType?: string): boolean {
    const sftpConnectionTypes = ['sftp', 'sftp1', 'sftp2', 'sftp_ssh', 'sftp_ssh1', 'sftp_ssh2'];
    return sftpConnectionTypes.some(ct => ct === connectionType?.toLowerCase());
}

export function isFsConnectionType(connectionType?: string): boolean {
    const fsConnectionTypes = ['fs1', 'fs2'];
    return fsConnectionTypes.some(ct => ct === connectionType?.toLowerCase());
}

export function isLegacyConnectionStringOnlyType(connectionType?: string): boolean {
    return legacyConnectionStringOnlyTypes.some(ct => ct === connectionType?.toLowerCase());
}

export function isFiveTranConnectionType(connectionType?: string): boolean {
    return connectionType?.toLowerCase() === 'fivetran';
}

export function isLegacyConnectionType(connectionType: string | undefined): boolean {
    return legacyConnectionTypes.some(ct => ct === connectionType?.toLowerCase());
}

export function areConnectionTypesCompatible(
    connectionFamily1: ConnectionFamilyType | null,
    connectionFamily2: ConnectionFamilyType | null
): boolean {
    return (
        connectionFamily1 === connectionFamily2 ||
        (isDatabaseConnectionType(connectionFamily1) && isDatabaseConnectionType(connectionFamily2)) ||
        (isFileConnectionType(connectionFamily1) && isFileConnectionType(connectionFamily2))
    );
}

export function isDatabaseConnectionType(connectionFamily?: ConnectionFamilyType | null): boolean {
    return !!connectionFamily && connectionFamily === ConnectionFamilyType.relational;
}

export function isFileConnectionType(connectionFamily?: ConnectionFamilyType | null): boolean {
    return !!connectionFamily && connectionFamily === ConnectionFamilyType.file;
}

// supported connection types have a defined connection family
export function isSupportedConnectionType(connectionFamily: ConnectionFamilyType | null): boolean {
    return connectionFamily === ConnectionFamilyType.file || connectionFamily === ConnectionFamilyType.relational;
}

export function isSupportedConnectionTypeMessage(connectionFamily: ConnectionFamilyType | null): string {
    return isSupportedConnectionType(connectionFamily) ? '' : tooltips.disabledUnsupportedSourceTypes;
}

const legacyConnectionTypes = [
    'azuresql',
    'azuresql3',
    'fs1',
    'fs2',
    'ora1',
    'ora2',
    'sftp',
    'sftp1',
    'sftp2',
    'sql',
    'sql1',
    'sql2',
    'ora1nc',
    'odbc1',
    'odbc2',
    'odbc',
    'adls1',
    'adls2',
    'adls',
    'symedical',
    'dbx',
    'dbxnote',
    'bigquery',
    'https'
];

const legacyConnectionStringOnlyTypes = [
    'odbc1',
    'odbc2',
    'odbc',
    'adls',
    'adls1',
    'adls2',
    'symedical',
    'dbx',
    'dbxnote',
    'bigquery',
    'https'
];
